module.exports = __webpack_public_path__ + "static/img/4954_phase_function_Paper_Points.b89b04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4954_phase_function_Paper_Points.png
// module id = if5I
// module chunks = 0